import { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Alert, Button } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import FadeAnimationDiv from 'components/common/Animations'
import { finishErrorAlert } from 'redux/alert/alert-actions'
import { RootState } from 'redux/store'
import { useTheme } from 'themes'

import { newFormThemeOverrides } from '../../styles'
import { IWarningAlertWithTextProps } from '../../types'
import { warningImg } from '../../utils'

const AlertWarningTextButton: FC<IWarningAlertWithTextProps> = ({ text, buttonText, pathname, handleClose }) => {
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })
    const [open] = useState(true)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { errorAlert } = useSelector((state: RootState) => state.alert)

    const handleClickButton = () => {
        if (errorAlert) {
            dispatch(finishErrorAlert())
        }
        navigate(`${pathname}`)
        handleClose()
    }

    return (
        <FadeAnimationDiv>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={formTheme}>
                    <Collapse in={open} timeout={500}>
                        <Alert icon={false} className="warning">
                            <div className="iconBox">
                                <img className="iconImg" src={warningImg} alt="Warning" />
                            </div>
                            <div className="message">
                                <span className="text">{text}</span>
                                <Button className="button" variant="outlined" onClick={handleClickButton}>
                                    {buttonText}
                                </Button>
                            </div>
                        </Alert>
                    </Collapse>
                </ThemeProvider>
            </StyledEngineProvider>
        </FadeAnimationDiv>
    )
}

export default AlertWarningTextButton
